<script setup lang="ts">
import VideoGrid from '@/shared/components/VideoGrid.vue'
import { TIP_GROUPS, VIDEOS } from '../content/tips'
</script>

<template>
    <section id="tips" class="site-section alt">
        <div class="site-content">
            <span class="kicker" v-reveal>The routine</span>
            <h2 v-reveal>Keep it healthy</h2>
            <p class="muted intro">
                A season-by-season routine that prevents most of the failures the troubleshooter
                above exists for.
            </p>

            <div class="seasons">
                <div v-for="(group, i) in TIP_GROUPS" :key="group.season" v-reveal="i * 70" class="season glass">
                    <h3>{{ group.icon }} {{ group.season }}</h3>
                    <ul>
                        <li v-for="tip in group.tips" :key="tip">{{ tip }}</li>
                    </ul>
                </div>
            </div>

            <h3 class="videos-head">Watch it done</h3>
            <VideoGrid :videos="VIDEOS" />
        </div>
    </section>
</template>

<style scoped lang="scss">
.alt {
    background-color: var(--site-bg-alt);
    background-image: var(--site-pattern, none);
}

.intro {
    max-width: 40rem;
}

.seasons {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: var(--site-space-md);
    margin: var(--site-space-lg) 0 var(--site-space-xl);
}

.season {
    padding: var(--site-space-lg);
    border-top: 3px solid var(--site-accent);

    h3 {
        font-size: 1.05rem;
        margin-bottom: var(--site-space-sm);
    }

    ul {
        margin: 0;
        padding-left: 1.2rem;
        display: grid;
        gap: var(--site-space-xs);
        font-size: 0.92rem;
        color: var(--site-text-muted);
    }
}

.videos-head {
    margin-bottom: var(--site-space-md);
}
</style>
